// Cars and Minivans defined sort order
var __carsAndMinivansSortOrder = [
  'yaris',
  'yarishatchback',
  'corolla',
  'corollahybrid',
  'corollahatchback',
  'prius',
  'camry',
  'camryhybrid',
  'priusprime',
  'avalon',
  'avalonhybrid',
  'mirai',
  '86',
  'supra',
  'sienna'
];

export default function sortCarsAndMinivansList(carsAndMinivansArray, mode) {
  // compare landing uses series raw while the nav uses the transform done
  // by series.latest.js, which is why the different 'seriesCode' vs. 'series_code'
  if (mode && mode === 'compare') {
    carsAndMinivansArray.sort(function (a, b) {
      return __carsAndMinivansSortOrder.indexOf(a.seriesCode) - __carsAndMinivansSortOrder.indexOf(b.seriesCode);
    });
  } else {
    carsAndMinivansArray.sort(function (a, b) {
      return __carsAndMinivansSortOrder.indexOf(a.series_code) - __carsAndMinivansSortOrder.indexOf(b.series_code);
    });
  }

  return carsAndMinivansArray;
}
